import { ControllerRenderProps, MultiSelect } from '@otp/ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { UserMergeRequestReason } from 'src/graphql/generated/graphql';

type ReasonProps = {
  field: ControllerRenderProps<any, any>;
  className?: string;
};

export const ReasonField = ({ field, className }: ReasonProps) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'user-merge-requests.form.fields.reason',
  });

  const options = useMemo(() => {
    return [
      {
        value: UserMergeRequestReason.OwnershipChange,
        name: t('ownership-change'),
      },
      {
        value: UserMergeRequestReason.JoinedNewOrganization,
        name: t('joined-new-organization'),
      },
      { value: UserMergeRequestReason.Other, name: t('other') },
    ];
  }, []);

  const defaultReasonValue = field.value;

  return (
    <MultiSelect
      key={field.value}
      multiple={false}
      fullWidth={true}
      className={className}
      options={options}
      defaultValue={defaultReasonValue}
      {...field}
      value={undefined}
      ref={undefined}
    />
  );
};
